import { render, staticRenderFns } from "./pierre-usseglio.vue?vue&type=template&id=25b7e4e2&scoped=true"
import script from "./pierre-usseglio.vue?vue&type=script&lang=js"
export * from "./pierre-usseglio.vue?vue&type=script&lang=js"
import style0 from "./pierre-usseglio.vue?vue&type=style&index=0&id=25b7e4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b7e4e2",
  null
  
)

export default component.exports